import Close from 'assets/icons/md/md-close.svg'

Close.displayName = 'Close'
export default Close
